import IframeActivity from "./IframeActivity";

export default function Meditation() {
    return (
        <IframeActivity
            src="/activities/meditation/index.html"
            title="Follow the Golden Snitch"
        />
    );
}